import { StatusPillTone } from '../UI/StatusPill/StatusPill';
import { SenderStatus } from '../types';

export const SENDER_STATUS: Record<SenderStatus, { label: string; tone: StatusPillTone }> = {
    unconfigured: { label: 'Not set up', tone: 'neutral' },
    pending: { label: 'Pending verification', tone: 'warning' },
    verified: { label: 'Verified', tone: 'success' },
    failed: { label: 'Verification failed', tone: 'error' }
};
